import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../form/button/button';
import { useRootStore } from '../../../../../providers/root-store-provider';

type SourceSurveyDialogActionProps = {
    onContinue: () => void;
};

export const SourceSurveyDialogAction: React.FC<SourceSurveyDialogActionProps> = observer(
    ({ onContinue }: SourceSurveyDialogActionProps) => {
        const { t } = useTranslation();
        const { sourceSurveyStore } = useRootStore();

        return (
            <>
                <Button
                    variant="positive"
                    block
                    disabled={sourceSurveyStore.source === null}
                    onClick={onContinue}
                    size={'large'}
                    loading={sourceSurveyStore.loading}
                >
                    {t('dialogs.sourceSurvey.button.continue')}
                </Button>
            </>
        );
    },
);
